import { GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import ResponsibleInvestment from "~/views/responsible-investment-principles"

const getInitialProps: GetInitialPropsType = async ({ req }) => {
  const crumbs = generateCrumbs(req?.url)
  return { crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
ResponsibleInvestment.getInitialProps = getInitialProps

export default ResponsibleInvestment
